const install = (Vue, vm) => {
	uni.$u.http.setConfig((config) => {
	    config.baseURL = vm.$baseUrl;
		config.timeout = 60000;
	    return config;
	})
	
	let wxLogin = (params = {}) => vm.$u.http.get('web/account/wxLogin',{ params });	// 登录
	let wxAuthPhone = (data = {}) => vm.$u.http.post('web/account/wxAuthPhone', data);	// 登录
	let applyForIdentity = (data = {}) => uni.$u.http.post('web/user/applyForIdentity', data)	// 申请身份信息
	let editMemberInfo = (data = {}) => uni.$u.http.post('web/user/editMemberInfo',data)	// 编辑个人信息
	let editUseIdentity = (data = {}) => vm.$u.http.post('web/user/editUseIdentity', data);	// 切换用工身份
	let getIdentityInfo = (params = {}) => vm.$u.http.get('web/user/getIdentityInfo', { params });	// 获取身份认证信息
	let getMemberInfo = (params = {}) => vm.$u.http.get('web/user/getMemberInfo', { params });	// 获取个人信息
	let revenuePage = (data = {}) => vm.$u.http.post('web/user/revenuePage',data);	// 余额明细 
	let updateIdentity = (data = {}) => vm.$u.http.post('web/user/updateIdentity', data);	// 修改身份信息（认证失败后使用）
	let updateLocation = (data = {}) => vm.$u.http.post('web/user/updateLocation', data);	// 修改身份信息位置（认证成功后使用）
	let accept = (params = {}) => vm.$u.http.get('web/orders/accept', { params });	// 手动接单 - 接单方
	let begin = (params = {}) => vm.$u.http.get('web/orders/begin', { params });	// 开始作业 - 发单方
	let comment = (data = {}) => vm.$u.http.post('web/orders/comment', data);	// 订单评价 - 发单方
	let confirmUpd = (data = {}) => vm.$u.http.post('web/orders/confirmUpd',data);	// 确认订单修改 - 接单方
	let doneOrder = (data = {}) => vm.$u.http.post('web/orders/doneOrder', data);	// 完成订单 - 发单方
	let getDetail = (params = {}) => vm.$u.http.get('web/orders/getDetail', { params });	// 订单详情
	let orderPage = (data) => vm.$u.http.post('web/orders/page', data);	// 分页查询
	let receiveCancelOrder = (params = {}) => vm.$u.http.get('web/orders/receiveCancelOrder', { params });	// 取消接单 - 接单方
	let releaseCancelOrder = (params = {}) => vm.$u.http.get('web/orders/releaseCancelOrder', { params });	// 取消接单 - 接单方
	let release = (data = {}) => vm.$u.http.post('web/orders/release', data);	// 发布订单 - 发单方
	let updOrderData = (data = {}) => vm.$u.http.post('web/orders/updOrderData', data);	// 修改订单日期 - 发单方
	let updateOrder = (data = {}) => vm.$u.http.post('web/orders/updateOrder', data);	// 修改订单 - 发单方
	let getCategoryList = (params = {}) => vm.$u.http.get('web/orders/getCategoryList', { params });	// 获取分类列表
	let getTotal = (data = {}) => vm.$u.http.post('web/orders/getTotal', data);	// 获取预计金额（分）
	
	let upload = (data = {}) => vm.$u.http.post('web/public/upload', data);	// 上传 
	 	
	vm.$u.api = {
		wxLogin,
		wxAuthPhone,
		applyForIdentity,
		editMemberInfo,
		editUseIdentity,
		getIdentityInfo,
		getMemberInfo,
		revenuePage,
		updateIdentity,
		updateLocation,
		accept,
		begin,
		comment,
		confirmUpd,
		doneOrder,
		getDetail,
		orderPage,
		receiveCancelOrder,
		releaseCancelOrder,
		release,
		updOrderData,
		updateOrder,
		getCategoryList,
		upload,
		getTotal	
	};
}

export default { install }